import React, { Component } from 'react';

import Logo from '../Logo/Logo';
import Menu from '../Menu/Menu';
import Lang from '../Lang/Lang';
import JetLogo from '../JetLogo/JetLogo';

import './Header.scss';

class Header extends Component {
  render() {
    return (
      <header className="header" id="top-section">
        <div className="header__holder">
          <Logo />
          <Menu />
          {/* <Lang /> */}
          <div className="header__jet-logo">
            <JetLogo color="white" />
          </div>
        </div>
      </header>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js